var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 0.75H18.6667C18.954 0.75 19.2295 0.864137 19.4327 1.0673C19.6359 1.27047 19.75 1.54602 19.75 1.83333V19.1667C19.75 19.454 19.6359 19.7295 19.4327 19.9327C19.2295 20.1359 18.954 20.25 18.6667 20.25H1.33333C1.04602 20.25 0.770465 20.1359 0.567301 19.9327C0.364137 19.7295 0.25 19.454 0.25 19.1667V1.83333C0.25 1.54602 0.364137 1.27047 0.567301 1.0673C0.770465 0.864137 1.04602 0.75 1.33333 0.75ZM2.41667 2.91667V18.0833H17.5833V2.91667H2.41667ZM8.91667 9.41667V5.08333H11.0833V9.41667H15.4167V11.5833H11.0833V15.9167H8.91667V11.5833H4.58333V9.41667H8.91667Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBox);
export default __webpack_public_path__ + "static/media/Plus-Box.183e7581e10515c714a60ba2cd1bfd49.svg";
export { ForwardRef as ReactComponent };